import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=740f9bd8&"
import script from "./LanguageSwitcher.js?vue&type=script&lang=js&"
export * from "./LanguageSwitcher.js?vue&type=script&lang=js&"
import style0 from "./LanguageSwitcher.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports